import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=4d1c955b&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c955b",
  null
  
)

export default component.exports